/**
 * External Imports
 */
import styled from 'styled-components';

/**
 * Nexus Imports
 */
import { NeuImage, NeuIcon } from '@neutron/react';

/**
 * Style Imports
 */
import { StyledLabel } from '../../../shared/table/Table.styles';

export const IconDiv = styled.div`
  display: flex;
  justify-content: end;
  align-items: center;
  margin-right: 5px;
  width: 22px;
`;

export const AvatarDiv = styled.div`
  padding-top: 5px;
`;

export const EmployeeInfoDiv = styled.div`
  display: flex;
  align-items: center;
`;

export const EmployeeAvatar = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 50%;
`;

export const LastValidationLabel = styled(StyledLabel)`
  flex: 0 0 100px;
`;

export const OverdueImg = styled(NeuImage)``;

export const ToDoIcon = styled(NeuIcon)`
  font-size: 12px;
  padding-right: 5px;
`;

export const CompleteIcon = styled(NeuIcon)`
  color: #00558c;
  font-size: 24px;
`;
